module.exports = __webpack_public_path__ + "img/sex-woman.6bd65c8b.svg";